var code = {
    // The following parameters are used for error codes in the front-end SDK
    1000000: {
        "errcode": 13001,
        "errmsg": "Initialization failed, please try again later"
    },
    // Account, password, verification code errors
    // Validate if login account is empty
    1010000: {
        "errcode": 11008,
        "errmsg": "Please enter login account"
    },
    // Validate mobile verification code error
    1010001: {
        "errcode": 11007,
        "errmsg": "Verification code error"
    },
    // Validate if password login password is empty
    1010002: {
        "errcode": 11011,
        "errmsg": "Please enter password"
    },
    // Validate if the tag identifier for changing the mobile number is empty
    1010003: {
        "errcode": 11702,
        "errmsg": "The tag for changing the mobile number cannot be empty"
    },
    // Mobile number validation
    1010004: {
        "errcode": 11003,
        "errmsg": "Invalid mobile number"
    },
    // Verification type cannot be empty
    1010005: {
        "errcode": 11801,
        "errmsg": "Verification type cannot be empty"
    },
    // Validate if the mobile number is empty
    1010006: {
        "errcode": 11002,
        "errmsg": "Please enter a mobile number"
    },
    // Validate mobile number legality
    1010007: {
        "errcode": 11003,
        "errmsg": "Incorrect mobile number format"
    },
    // Validate if the mobile verification code is empty
    1010008: {
        "errcode": 11006,
        "errmsg": "Please enter the verification code"
    },
    // Validate if the old mobile verification code is empty when forgetting the password
    1010009: {
        "errcode": 11803,
        "errmsg": "Please enter the verification code"
    },
    // Account security validation mobile number legality
    1010011: {
        "errcode": 11508,
        "errmsg": "Incorrect mobile number format"
    },
    // Account security validation if the mobile number is empty
    1010012: {
        "errcode": 11507,
        "errmsg": "Please enter a mobile number"
    },
    // Account security validation verification code legality
    1010013: {
        "errcode": 11804,
        "errmsg": "Verification code error"
    },
    // Account security validation if the password is empty
    1010014: {
        "errcode": 11601,
        "errmsg": "Please enter the correct password information"
    },
    // Account security validation password legality
    1010015: {
        "errcode": 11602,
        "errmsg": "Please follow the password rules to set a new password"
    },
    // Validate the legality of the verification code for changing the mobile number
    1010016: {
        "errcode": 11703,
        "errmsg": "Verification code error"
    },
    // Email cannot be empty
    1010017: {
        "errcode": 11526,
        "errmsg": "Please enter an email"
    },
    // Incorrect email format
    1010018: {
        "errcode": 11527,
        "errmsg": "Incorrect email format"
    },
    // Embedded id cannot be empty
    1010019: {
        "errcode": 11528,
        "errmsg": "Verification code container id cannot be empty"
    },
    // Codes related to personal information
    // Validate the legality of the passport
    1020000: {
        "errcode": 12005,
        "errmsg": "Incorrect passport format"
    },
    // Validate the legality of the nickname
    1020001: {
        "errcode": 12011,
        "errmsg": "Incorrect nickname format"
    },
    // Validate the legality of the real name
    1020002: {
        "errcode": 12008,
        "errmsg": "Incorrect real name format"
    },
    // Validate the legality of the English name
    1020003: {
        "errcode": 12007,
        "errmsg": "Incorrect English name format"
    },
    // Validate the legality of the birthday information
    1020004: {
        "errcode": 12018,
        "errmsg": "Incorrect birthday information format"
    },
    // Validate the legality of the current grade
    1020005: {
        "errcode": 12014,
        "errmsg": "Illegal grade"
    },
    1020006: {
        "errcode": 12202,
        "errmsg": "Unsupported image format, please re-select and upload"
    },
    // Codes related to address information
    1030000: {
        "errcode": 12519,
        "errmsg": "Invalid address id"
    },
    // Validate the legality of the recipient information
    1030001: {
        "errcode": 12503,
        "errmsg": "Incorrect recipient name format"
    },
    1030002: {
        "errcode": 12509,
        "errmsg": "Invalid postal code"
    },
    // Validate the legality of the detailed recipient address information
    1030003: {
        "errcode": 12517,
        "errmsg": "Incorrect detailed address format"
    },
    // Validate the legality of the remark information length
    1030004: {
        "errcode": 12521,
        "errmsg": "Incorrect remark information format"
    },
    // Validate if the recipient name is empty
    1030005: {
        "errcode": 12502,
        "errmsg": "Please enter the recipient name"
    },
    // Validate if the recipient mobile number is empty
    1030006: {
        "errcode": 12506,
        "errmsg": "Please enter a contact number"
    },
    // Validate the legality of the recipient mobile number
    1030007: {
        "errcode": 12507,
        "errmsg": "Incorrect contact number format"
    },
    // Validate if the detailed recipient address information is empty
    1030008: {
        "errcode": 12516,
        "errmsg": "Please enter a detailed address"
    },
    // Regional format errors
    // Validate the legality of the province information
    1040000: {
        "errcode": 12511,
        "errmsg": "Incorrect province information format"
    },
    // Validate the legality of the city information
    1040001: {
        "errcode": 12513,
        "errmsg": "Incorrect city information format"
    },
    // Validate the legality of the district information
    1040002: {
        "errcode": 12515,
        "errmsg": "Incorrect district information format"
    },
    // Validate if the province information is empty
    1040003: {
        "errcode": 12510,
        "errmsg": "Please select province information"
    },
    // Validate if the city information is empty
    1040004: {
        "errcode": 12512,
        "errmsg": "Please select city information"
    },
    // Validate if the district information is empty
    1040005: {
        "errcode": 12514,
        "errmsg": "Please select district information"
    },
    // Validate if the avatar tai_id is empty
    1040006: {
        "errcode": 10003,
        "errmsg": "Parameter request exception, please try again later"
    },
    // Validate if the AES encryption resource file is loaded successfully
    1000002: {
        "errcode": 13002,
        "errmsg": "AES encryption resource file crypto initialization failed, please try again later"
    },
    // Institution related error messages
    // Non-institution calls institution methods
    1050001: {
        "errcode": '13003',
        "errmsg": "Non-institution calls institution methods, please configure whether it is an institution call"
    },
    // Institution country code is empty
    1050002: {
        "errcode": '13004',
        "errmsg": "Please enter the mobile number country code"
    },
    // Institution mobile number is empty
    1050003: {
        "errcode": '13005',
        "errmsg": "Please enter the institution mobile number"
    },
    // Institution name is invalid
    1050004: {
        "errcode": '13006',
        "errmsg": "Incorrect institution name format"
    },
    // Avatar information is not empty
    1050005: {
        "errcode": '10003',
        "errmsg": "Avatar information is not empty or remove the upload avatar parameter"
    },
};

for (let key in code) {
    code[key].errsource = 'front'
}

module.exports = code;



// WEBPACK FOOTER //
// ./src/codeEn.js